import ApiService from './api.service';

class ListasProveedorService extends ApiService {
  constructor() {
    super('/productos/listas-proveedor');
  }

  async listar(proveedorId) {
    const params = proveedorId ? { proveedor_id: proveedorId } : {};
    const res = await this.get('', params);
    if (res.status >= 400) {
      throw new Error(res.data?.message || 'No se pudieron leer las listas');
    }
    if (!Array.isArray(res.data?.data)) {
      throw new Error(res.data?.message || 'La respuesta no trae las listas');
    }
    return res.data.data;
  }

  async previsualizar(payload) {
    const res = await this.post('/previsualizar', payload);
    if (res.status >= 400) {
      throw new Error(res.data?.message || 'No se pudo leer el archivo');
    }
    return res.data?.data;
  }

  async guardar(payload) {
    const res = await this.post('', payload);
    if (res.status >= 400) {
      const error = new Error(res.data?.message || 'No se pudo guardar la lista');
      error.code = res.data?.code;
      error.payload = res.data;
      throw error;
    }
    return res.data;
  }
}

const listasProveedorService = new ListasProveedorService();
export default listasProveedorService;
